<template>
   <div class="text-right my-3">
    <a href="#/" @click="deleteProject(project.id)" class="link">Delete Project</a></div>
</template>

<script>
export default {
  props: ['project'],

  data() {
    return {
        deleting: false,
    };
  },



  methods: {


    sweetfire(text) {

      Swal.fire({
      title: text,
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: true,
      focusConfirm: false,
      cancelButtonText: 'Ok',
      customClass: {
              title: "popup-title",
            },
    })

    },
  
    deleteProject() {

      Swal.fire({
      title: 'Are you sure you want to delete this project?',
      showConfirmButton: false,
      showDenyButton: true,
      showCancelButton: true,
      focusConfirm: false,
      // position: 'top',
      // showCloseButton: true,
      // confirmButtonText: 'Yes, delete it',
      denyButtonText: 'Yes, delete it',
      customClass: {
              title: "popup-title",
            },
    }).then((result) => {

    if (result.isDenied) {
        
        this.deleteProjectAction(this.project.id);

      } 

    })

    },

    deleteProjectAction() {

      let existingObj = this;

      axios
        .post("/projects/delete", {id: this.project.id})
        .then(function (response) {
          console.log(response.data);
          if (response.data.success) {
            window.open("/projects", "_self");
          } else {
            existingObj.showMessage(response.data.message);
          }
        })
        .catch(function (err) {
          console.log(err);
        });

    },

    showMessage(text) {

      Swal.fire({
          timer: 2000,
          title: text,
          showConfirmButton: false,
        customClass: {
              title: "popup-title",
            }});

    },

  },
};
</script> 


<style scoped>
.link { color:#e55171; }
</style>

